import React from "react";
import SiteHeader from "../SiteHeader";
import Layout from "../Layout";
import Seo from "../SEO";
import SiteFooterV2 from "../SiteFooterV2";
import AnnouncementBar from "../AnnouncementBar";
import * as styles from "./styles.module.scss";

export default function BasePage({
  pageContext,
  location,
  seoImage,
  children
}) {
  const isFooterVisible = pageContext?.hideFooter !== true; //I know, super backwards logic
  return (
    <Layout>
      <Seo
        title={pageContext?.seoTitle}
        description={pageContext?.seoDescription}
        keywords={pageContext?.seoKeywords}
        image={seoImage}
      />
      <div className={styles.sticky}>
        <AnnouncementBar />
        {pageContext?.hideHeader === true ? null : (
          <SiteHeader location={location} />
        )}
      </div>

      {children}

      {isFooterVisible && <SiteFooterV2 />}
    </Layout>
  );
}
